import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 6.583a2.167 2.167 0 1 0 0 4.333 2.167 2.167 0 0 0 0-4.333ZM6.833 8.75a1.167 1.167 0 1 1 2.334 0 1.167 1.167 0 0 1-2.334 0Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.667 2.583a.5.5 0 0 0-.431.246L.902 8.496a.5.5 0 0 0 0 .507l3.334 5.667a.5.5 0 0 0 .43.246h6.667a.5.5 0 0 0 .431-.246l3.334-5.667a.5.5 0 0 0 0-.507L11.764 2.83a.5.5 0 0 0-.43-.246H4.666ZM1.913 8.75l3.04-5.167h6.094l3.04 5.167-3.04 5.166H4.953L1.913 8.75Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }